import { changeCountriesState } from '../../../../stores/GlobalState'
import { observer } from 'mobx-react'
import Globus from '../../../common/Globus'
import { useEffect } from 'react'
import { ReactComponent as Vector } from '../../../../assets/about/Vector.svg'
import { ReactComponent as AnimArrow } from '../../../../assets/about/anim-arrow.svg'
import ContentState from '../../../../stores/ContentState'
import './index.scss'

const Intro = observer(() => {
  const content = ContentState
  useEffect(() => {
    if (!content.about?.intro) return
    setTimeout(() => {
      let vh = window.innerHeight * 0.01
      ;(document.querySelector('.intro') as HTMLElement)?.style.setProperty(
        '--vh',
        `${vh}px`,
      )
      document.querySelector('.intro__anim-arrow')?.classList.add('anim')
    }, 1000)
  }, [content.about?.intro])

  useEffect(() => {
    if (!content.about?.intro) return
    window.addEventListener(
      'orientationchange',
      () => {
        setTimeout(() => {
          if (window.orientation == 90 || window.orientation == -90) {
            let vh = window.innerHeight * 0.01
            ;(document.querySelector(
              '.intro',
            ) as HTMLElement)?.style.setProperty('--vh', `${vh}px`)
          } else {
            let vh = window.innerHeight * 0.01
            ;(document.querySelector(
              '.intro',
            ) as HTMLElement)?.style.setProperty('--vh', `${vh}px`)
          }
        }, 1000)
      },
      false,
    )
  }, [content.about?.intro])

  return (
    <>
      <section className="intro">
        <div className="intro__container">
          <div className="intro__col">
            <div
              className="intro__title"
              dangerouslySetInnerHTML={{
                __html: content.about?.intro.title || '',
              }}
            ></div>
            <div className="intro__more" onClick={changeCountriesState}>
              <Vector /> <span>{content.about?.intro.showCountries}</span>
            </div>
          </div>
          <Globus />
        </div>
        <AnimArrow
          className="intro__anim-arrow"
          onClick={() => {
            const anchor = document.querySelector(`.intro`)?.nextElementSibling

            if (anchor) {
              anchor.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest',
              })
            }
          }}
        />
      </section>
    </>
  )
})

export default Intro
